/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Compare_TitleInputs */

const en_fc_home_paths_compare_title = /** @type {(inputs: Fc_Home_Paths_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft vs Premiere Pro`)
};

/**
* | output |
* | --- |
* | "FilmCraft vs Premiere Pro" |
*
* @param {Fc_Home_Paths_Compare_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_compare_title = /** @type {((inputs?: Fc_Home_Paths_Compare_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Compare_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_compare_title(inputs)
});
export { fc_home_paths_compare_title as "fc.home.paths.compare.title" }